export enum MenuLocationEnum {
  ABOVE_PRIMARY_NAVIGATION = "ABOVE_PRIMARY_NAVIGATION",
  FOOTER_NAVIGATION = "FOOTER_NAVIGATION",
  LEGAL_NAVIGATION = "LEGAL_NAVIGATION",
  PRIMARY_NAVIGATION = "PRIMARY_NAVIGATION",
}
